import { useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileSearch, Sparkles, X } from "lucide-react";

export const LiteUpgradeBanner = ({ locked }) => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("liteUpgradeDismissed") === "1"
  );

  if (!locked || dismissed) return null;

  const dismiss = () => {
    sessionStorage.setItem("liteUpgradeDismissed", "1");
    setDismissed(true);
  };

  return (
    <Card className="overflow-hidden border-0 shadow-md mb-6 animate-fade-in" data-testid="lite-upgrade-banner">
      <div className="bg-gradient-to-r from-[#547d91] to-[#3f6273] text-white p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
            <FileSearch className="w-6 h-6" />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-heading text-lg font-semibold">Unlock the AI Buyers Agent</h3>
              <span className="text-[10px] font-semibold bg-white/20 rounded px-1.5 py-0.5">You're on Pocket BA Lite</span>
            </div>
            <p className="text-white/85 text-sm mt-1 max-w-xl">
              Generate instant due-diligence reports, AI price &amp; rental estimates and chat with an AI property advisor.
              Start a 7-day free trial — cancel anytime.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Link to="/property-researcher">
            <Button className="bg-white text-[#3f6273] hover:bg-white/90 rounded-full px-5" data-testid="lite-upgrade-btn">
              <Sparkles className="w-4 h-4 mr-2" /> Start free trial
            </Button>
          </Link>
          <Button
            variant="ghost"
            size="icon"
            onClick={dismiss}
            className="text-white/80 hover:text-white hover:bg-white/10"
            data-testid="dismiss-lite-banner-btn"
          >
            <X className="w-5 h-5" />
          </Button>
        </div>
      </div>
    </Card>
  );
};
